import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7364 6.26361C15.0879 6.61508 15.0879 7.18493 14.7364 7.5364L10.2728 12L14.7364 16.4636C15.0879 16.8151 15.0879 17.3849 14.7364 17.7364C14.3849 18.0879 13.8151 18.0879 13.4636 17.7364L8.3636 12.6364C8.01213 12.2849 8.01213 11.715 8.36361 11.3636L13.4636 6.2636C13.8151 5.91213 14.3849 5.91213 14.7364 6.26361Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }